import { render, staticRenderFns } from "./LessonsAdd.vue?vue&type=template&id=1ba1becf"
import script from "./LessonsAdd.vue?vue&type=script&lang=js"
export * from "./LessonsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports